import React, { ComponentProps, FunctionComponent } from "react";

const LogoFacebookIcon = (
  {
    title,
    titleId,
    ...props
  }: { title?: string; titleId?: string } & React.ComponentProps<"svg">,
  svgRef: any
) => {
  return /*#__PURE__*/ React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 17 17",
        fill: "none",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId,
      },
      props
    ),
    title
      ? /*#__PURE__*/ React.createElement(
          "title",
          {
            id: titleId,
          },
          title
        )
      : null,
    /*#__PURE__*/ React.createElement("path", {
      stroke: "currentColor",
      strokeWidth: "1.59992",
      d: "M16.0967 15.5422C16.0967 15.6524 16.0069 15.7422 15.8967 15.7422H1.89741C1.78724 15.7422 1.69742 15.6524 1.69742 15.5422V1.54292C1.69742 1.43275 1.78724 1.34293 1.89741 1.34293H15.8967C16.0069 1.34293 16.0967 1.43275 16.0967 1.54292V15.5422Z",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fill: "currentColor",
      d: "M11.8972 16.5423V10.5426H13.8971L14.3971 8.04272H11.8972V7.04277C11.8972 6.04282 12.3982 5.54285 13.3972 5.54285H14.3971V3.04297C13.8971 3.04297 13.2772 3.04297 12.3972 3.04297C10.5598 3.04297 9.39736 4.4834 9.39736 6.5428V8.04272H7.39746V10.5426H9.39736V16.5423H11.8972Z",
    })
  );
};

const ForwardRef = React.forwardRef(LogoFacebookIcon) as FunctionComponent<
  ComponentProps<"svg">
>;

export default ForwardRef;
